import React from 'react'
import styles from './PayFeeBtn.module.css'
import { Link } from 'react-router-dom'

const PayFeeBtn: React.FC = () => {
  return (
    <div className={`${styles.btnWrapper} border border-appRed mt-1`}>
      <Link
        to="/payment"
        className={`${styles.link} w-full text-white border border-appDarkRed bg-appRed hover:bg-appDarkRed px-2 lg:px-4 py-3 flex flex-col justify-center items-center`}
      >
        <span className="font-semibold text-base flex flex-row items-center justify-center gap-x-3 w-full flex-nowrap">
          <i className="fas fa-coins"></i>Внести членский взнос
        </span>
      </Link>
    </div>
  )
}

export default PayFeeBtn
